/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Perk_PlanInputs */

const en_portal_perk_plan = /** @type {(inputs: Portal_Perk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training plan`)
};

const pl_portal_perk_plan = /** @type {(inputs: Portal_Perk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy`)
};

/**
* | output |
* | --- |
* | "Training plan" |
*
* @param {Portal_Perk_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_perk_plan = /** @type {((inputs?: Portal_Perk_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Perk_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_perk_plan(inputs)
	return en_portal_perk_plan(inputs)
});